module.exports = __webpack_public_path__ + "media/images/redesign-images/textures/texture-5-5ba3a2ea1526e34a950181d67dd8d6bb.svg";